import { Dialog, Transition } from '@headlessui/react'
import { Fragment } from 'react'
import React, { useState } from "react";
import ImageDialog from "./ImageDialog";


const BraceletsSizeDialog = ({ isOpen, onClose }) => {

    const [isShowMeasurement, setShowMeasurement] = useState(false);

    return (
        <div>
            <Transition appear show={isOpen} as={Fragment}>
                <Dialog as="div" className="relative z-[10000]" onClose={onClose}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-black/25" />
                    </Transition.Child>

                    <div className="fixed inset-0 overflow-y-auto">
                        <div className="flex min-h-full items-center justify-center p-4 text-center">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 scale-95"
                                enterTo="opacity-100 scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 scale-100"
                                leaveTo="opacity-0 scale-95"
                            >
                                <Dialog.Panel className="w-full max-w-xl transform rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                                    <Dialog.Title
                                        as="h3"
                                        className="text-md md:text-lg font-medium leading-6 text-gray-900"
                                    >
                                        Bracelet Size Chart (Indian Size)
                                    </Dialog.Title>
                                    <div className="w-full h-auto pt-2">
                                        <div className="w-full flex flex-col gap-5">
                                            <table className=" border-collapse border border-slate-500 ">
                                                <caption className="underline cursor-pointer font-[700] text-[#000080] py-2 md:text-md text-lg" onClick={() => setShowMeasurement(true)}>
                                                    How to Measurement Size
                                                </caption>
                                                <caption className="font-[700] text-[#000080] py-2 md:text-md text-lg">
                                                    Men Bracelets Size
                                                </caption>
                                                <tr className="text-center">
                                                    <th className="w-1/3 border border-slate-300 p-1 md:text-sm text-md">
                                                        Size
                                                    </th>
                                                    <th className="w-1/3 border border-slate-300 p-1 md:text-sm text-md">
                                                        Length (inches)
                                                    </th>
                                                    <th className="w-1/3 border border-slate-300 p-1 md:text-sm text-md">
                                                        Length (cm)
                                                    </th>
                                                </tr>
                                                <tr className="text-center">
                                                    <td className="border border-slate-300 p-1 md:text-sm text-md">
                                                        Small (S)
                                                    </td>
                                                    <td className="border border-slate-300 p-1 md:text-sm text-md">
                                                        6 - 6.5
                                                    </td>
                                                    <td className="border border-slate-300 p-1 md:text-sm text-md">
                                                        16.5 - 17.8
                                                    </td>
                                                </tr>
                                                <tr className="text-center">
                                                    <td className="border border-slate-300 p-1 md:text-sm text-md">
                                                        Medium (M)
                                                    </td>
                                                    <td className="border border-slate-300 p-1 md:text-sm text-md">
                                                        7 - 7.5
                                                    </td>
                                                    <td className="border border-slate-300 p-1 md:text-sm text-md">
                                                        17.8 - 19
                                                    </td>
                                                </tr>
                                                <tr className="text-center">
                                                    <td className="border border-slate-300 p-1 md:text-sm text-md">
                                                        Large (L)
                                                    </td>
                                                    <td className="border border-slate-300 p-1 md:text-sm text-md">
                                                        7.5 - 8
                                                    </td>
                                                    <td className="border border-slate-300 p-1 md:text-sm text-md">
                                                        19 - 20.3
                                                    </td>
                                                </tr>
                                                <tr className="text-center">
                                                    <td className="border border-slate-300 p-1 md:text-sm text-md">
                                                        X-Large (XL)
                                                    </td>
                                                    <td className="border border-slate-300 p-1 md:text-sm text-md">
                                                        8 - 8.5
                                                    </td>
                                                    <td className="border border-slate-300 p-1 md:text-sm text-md">
                                                        20.3 - 21.3
                                                    </td>
                                                </tr>
                                            </table>

                                            <table className="w-full border-collapse border border-slate-500 ">
                                                <caption className="font-[700] text-[#000080] py-2 md:text-md text-lg">
                                                    Women Bracelets Size
                                                </caption>
                                                <tr className="text-center">
                                                    <th className="w-1/3 border border-slate-300 p-1 md:text-sm text-md">
                                                        Size
                                                    </th>
                                                    <th className="w-1/3 border border-slate-300 p-1 md:text-sm text-md">
                                                        Length (inches)
                                                    </th>
                                                    <th className="w-1/3 border border-slate-300 p-1 md:text-sm text-md">
                                                        Length (cm)
                                                    </th>
                                                </tr>
                                                <tr className="text-center">
                                                    <td className="border border-slate-300 p-1 md:text-sm text-md">
                                                        Small (S)
                                                    </td>
                                                    <td className="border border-slate-300 p-1 md:text-sm text-md">
                                                        5 - 5.6
                                                    </td>
                                                    <td className="border border-slate-300 p-1 md:text-sm text-md">
                                                        14 - 15.2
                                                    </td>
                                                </tr>
                                                <tr className="text-center">
                                                    <td className="border border-slate-300 p-1 md:text-sm text-md">
                                                        Medium (M)
                                                    </td>
                                                    <td className="border border-slate-300 p-1 md:text-sm text-md">
                                                        6 - 6.5
                                                    </td>
                                                    <td className="border border-slate-300 p-1 md:text-sm text-md">
                                                        15.2 - 16.5
                                                    </td>
                                                </tr>
                                                <tr className="text-center">
                                                    <td className="border border-slate-300 p-1 md:text-sm text-md">
                                                        Large (L)
                                                    </td>
                                                    <td className="border border-slate-300 p-1 md:text-sm text-md">
                                                        6.5 - 7
                                                    </td>
                                                    <td className="border border-slate-300 p-1 md:text-sm text-md">
                                                        16.5 - 17.8
                                                    </td>
                                                </tr>
                                                <tr className="text-center">
                                                    <td className="border border-slate-300 p-1 md:text-sm text-md">
                                                        X-Large (XL)
                                                    </td>
                                                    <td className="border border-slate-300 p-1 md:text-sm text-md">
                                                        7 - 7.7
                                                    </td>
                                                    <td className="border border-slate-300 p-1 md:text-sm text-md">
                                                        17.8 - 19
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                    <div className="mt-4 text-right">
                                        <button
                                            className="inline-flex justify-center rounded-md bg-blue-500 px-4 py-2 text-sm text-white hover:bg-blue-600"
                                            onClick={onClose}
                                        >
                                            Close
                                        </button>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition>

            {/* Show */}
            <ImageDialog
                isOpen={isShowMeasurement}
                onClose={() => setShowMeasurement(false)}
                imageUrl={'/braceletGuidChart.png'}
            />
        </div>
    )
}

export default BraceletsSizeDialog
